import React, { useState, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import UserContext from '../../context/UserContext'

import { Typography, Paper, Icon, Button, Divider } from '@material-ui/core'
import { PeopleOutlined, NavigateNextOutlined, EditOutlined, SubjectOutlined, FormatListBulletedOutlined, DoneOutlineOutlined } from '@material-ui/icons'

import api from '../../services/api'

import './styles.css'

import { makeStyles } from '@material-ui/core/styles'

import { useAlert } from 'react-alert'

const useStyles = makeStyles({
    buttonStyle: {
        margin: '5px',
        marginTop: '30px',
        marginBottom: '30px'
    },
    titleStyle: {
        margin: '15px',
        marginTop:'40px'
    },
    smallTitleStyle: {
        margin: '10px',
        color: '#002884'
    },
    smallerTitleStyle: {
        marginLeft: '8px',
        marginTop: '12px',
        marginBottom: '4px'
    },
    dividerStyle: {
        margin:'25px'
    },
    iconStyle: {
        fontSize: '12px'
    },
    editIconStyle: {
        color: '#388e3c'
    },
    innerTypStyle: {
        color: '#757575',
        fontSize: '12px',
        textTransform: 'uppercase',
        marginLeft: '6px',
    }
})

function Update() {

    const { userData } = useContext(UserContext)
    const history =  useHistory()
    const alert = useAlert()
    const classes = useStyles()

    // leitura info ata
    const [ata, setAta] = useState({
        participantesFN: [],
        participantesClientes: [],
        proximosPassos: []
    })

    const [assunto, setAssunto] = useState()
    const [pontosAbordados, setPontosAbordados] = useState()
    const [decisoesTomadas, setDecisoesTomadas] = useState()
    // array de objetos
    const [participantesFN, setParticipantesFN] = useState(ata.participantesFN.map(participanteFN => ({
        _id: participanteFN._id,
        emailFN: participanteFN.emailFN
    })))
    const [participantesClientes, setParticipantesClientes] = useState(ata.participantesClientes.map(participanteCliente => ({
        _id: participanteCliente._id,
        emailCliente: participanteCliente.emailCliente
    })))
    const [proximosPassos, setProximosPassos] = useState(ata.proximosPassos.map(proximoPasso => ({
        _id: proximoPasso._id,
        responsavel: proximoPasso.responsavel,
        tarefa: proximoPasso.tarefa,
        codigoRedmine: proximoPasso.codigoRedmine,
        prazo: proximoPasso.prazo
    })))

    useEffect(() => {
        if(!userData.user) {
            history.push("/")
        }
    })

    useEffect(() => {        
        async function ataInfoHandler() {
            try {
                let token = localStorage.getItem('auth-token')
                let ataId = localStorage.getItem('ata-id')
                const ataRes = await api.get(`/api/ata/minhas/${ataId}`, { headers: { "x-auth-token": token } })

                setAta(ataRes.data)

                setParticipantesFN(ataRes.data.participantesFN.map(participanteFN => ({
                    _id: participanteFN._id,
                    emailFN: participanteFN.emailFN
                })))
                setParticipantesClientes(ataRes.data.participantesClientes.map(participanteCliente => ({
                    _id: participanteCliente._id,
                    emailCliente: participanteCliente.emailCliente
                })))

                setAssunto(ataRes.data.assunto)
                setPontosAbordados(ataRes.data.pontosAbordados)
                setDecisoesTomadas(ataRes.data.decisoesTomadas)

                setProximosPassos(ataRes.data.proximosPassos.map(proximoPasso => ({
                    _id: proximoPasso._id,
                    responsavel: proximoPasso.responsavel,
                    tarefa: proximoPasso.tarefa,
                    codigoRedmine: proximoPasso.codigoRedmine,
                    prazo: proximoPasso.prazo
                })))

            } catch (err) {
                alert.show('Não foi possível receber os dados da ata de reunião. Por favor, tente novamente.', { title: "Algo deu errado.", closeCopy: "OK" })
                history.push('/perfil')
            }
        }
        ataInfoHandler()
    // eslint-disable-next-line
    }, [])

    async function submitHandler(e) {
        e.preventDefault()

        const data = {
            assunto,
            participantesFN,
            participantesClientes,
            pontosAbordados,
            decisoesTomadas,
            proximosPassos
        }

        try {
            let token = localStorage.getItem('auth-token')
            let ataId = localStorage.getItem('ata-id')
            await api.patch(`/api/ata/minhas/${ataId}`, data, { headers: { "X-Auth-Token": token, "content-type": "application/json" } })
            alert.show('A sua ata de reunião foi alterada.', { title: "Sucesso!", closeCopy: "OK" })
            history.push('/perfil')
        } catch (err) {
            alert.show('Não foi possível atualizar a ata de reunião. Por favor, tente novamente.', { title: "Algo deu errado.", closeCopy: "OK" })
        }
    }

    function changesHandler(e, participanteFN) {
        e.persist()

        setParticipantesFN((prevParticipanteFN) => {
                        
            const part = prevParticipanteFN.map(i => {
                    if (i._id === participanteFN._id) {
                        i.emailFN = e.target.value
                    }
                    return i
                }
            )
            return part                        
        })
    }

    function clienteChangesHandler(e, participanteCliente) {
        e.persist()

        setParticipantesClientes((prevParticipanteCliente) => {
                        
            const part = prevParticipanteCliente.map(i => {
                    if (i._id === participanteCliente._id) {
                        i.emailCliente = e.target.value
                    }
                    return i
                }
            )
            return part                        
        })
    }

    function passosChangesHandler(e, proximoPasso) {
        e.persist()

        setProximosPassos((prevProximoPasso) => {
                        
            const pass = prevProximoPasso.map(i => {
                    if (i._id === proximoPasso._id) {
                        i.responsavel = e.target.value
                    }
                    return i
                }
            )
            return pass                        
        })
    }

    function passosChangesHandler1(e, proximoPasso) {
        e.persist()

        setProximosPassos((prevProximoPasso) => {
                        
            const pass = prevProximoPasso.map(i => {
                    if (i._id === proximoPasso._id) {
                        i.tarefa = e.target.value
                    }
                    return i
                }
            )
            return pass                        
        })
    }

    function passosChangesHandler2(e, proximoPasso) {
        e.persist()

        setProximosPassos((prevProximoPasso) => {
                        
            const pass = prevProximoPasso.map(i => {
                    if (i._id === proximoPasso._id) {
                        i.codigoRedmine = e.target.value
                    }
                    return i
                }
            )
            return pass                        
        })
    }

    function passosChangesHandler3(e, proximoPasso) {
        e.persist()

        setProximosPassos((prevProximoPasso) => {
                        
            const pass = prevProximoPasso.map(i => {
                    if (i._id === proximoPasso._id) {
                        i.prazo = e.target.value
                    }
                    return i
                }
            )
            return pass                        
        })
    }

    return (
        <Paper elevation={6}>
        <div className="update-ata-container">
        <form onSubmit={submitHandler}>
            <Typography 
                className={classes.titleStyle} 
                align="center" 
                variant="h5" 
            >
                EDITAR <strong>ATA DE REUNIÃO</strong> <EditOutlined className={classes.editIconStyle} fontSize="small" />
            </Typography>

            <Typography 
                className={classes.smallTitleStyle} 
                align="left" 
                variant="overline"
            >
                Assunto <SubjectOutlined className={classes.iconStyle}/>
            </Typography>
            <input value={assunto} type="text" onChange={e => setAssunto(e.target.value)}/>

            <Divider 
                className={classes.dividerStyle} 
                variant="fullWidth"  
            />

            <Typography 
                className={classes.smallTitleStyle} 
                align="left" 
                variant="overline"
            >
                Participantes <PeopleOutlined className={classes.iconStyle} />
            </Typography>

            <Typography component={'span'} className={classes.innerTypStyle}>FN:</Typography>
            {participantesFN.map(participanteFN => (
                <input key={participanteFN._id} value={participanteFN.emailFN} type="email" onChange={(e) => changesHandler(e, participanteFN)}/>
            ))}

            <br/>
            <Typography component={'span'} className={classes.innerTypStyle}>Clientes:</Typography>
            {participantesClientes.map(participanteCliente => (
                <input key={participanteCliente._id} value={participanteCliente.emailCliente} type="email" onChange={(e) => clienteChangesHandler(e, participanteCliente)}/>
            ))}

            <Divider 
                className={classes.dividerStyle} 
                variant="fullWidth"  
            />

            <Typography 
                className={classes.smallTitleStyle} 
                align="left" 
                variant="overline"
            >
                Pontos abordados <FormatListBulletedOutlined className={classes.iconStyle}/>
            </Typography>
            <textarea value={pontosAbordados} type="text" onChange={e => setPontosAbordados(e.target.value)}/>

            <Divider 
                className={classes.dividerStyle} 
                variant="fullWidth"  
            />

            <Typography 
                className={classes.smallTitleStyle} 
                align="left" 
                variant="overline"
            >
                Decisões tomadas <DoneOutlineOutlined className={classes.iconStyle}/>
            </Typography>
            <textarea value={decisoesTomadas} type="text" onChange={e => setDecisoesTomadas(e.target.value)}/>

            <Divider 
                className={classes.dividerStyle} 
                variant="fullWidth"  
            />
            
            <Typography 
                className={classes.smallTitleStyle} 
                align="left" 
                variant="overline"
            >
                Próximos Passos <NavigateNextOutlined className={classes.iconStyle}/>
            </Typography>
            {proximosPassos.map(proximoPasso => (
                <>
                    <Typography component={'span'} className={classes.innerTypStyle}>Responsável: </Typography><input value={proximoPasso.responsavel} type="email" onChange={(e) => passosChangesHandler(e, proximoPasso)}/>
                    <Typography component={'span'} className={classes.innerTypStyle}>Tarefa: </Typography><textarea value={proximoPasso.tarefa} onChange={(e) => passosChangesHandler1(e, proximoPasso)}/>
                    <Typography component={'span'} className={classes.innerTypStyle}>Código Redmine: </Typography><input value={proximoPasso.codigoRedmine} type="number" onChange={(e) => passosChangesHandler2(e, proximoPasso)}/>
                    <Typography component={'span'} className={classes.innerTypStyle}>Prazo: </Typography><input value={proximoPasso.prazo} type="date" onChange={(e) => passosChangesHandler3(e, proximoPasso)}/>
                    <br/><br/>
                </>
            ))}

             <Button 
                variant="contained" 
                color="primary" 
                className={classes.buttonStyle} 
                endIcon={<Icon>send</Icon>}                            
                type="submit"
                // onClick={submitHandler}
            >
                Salvar alterações
            </Button>
            
        </form>
        </div>
        </Paper>
    )
}

export default Update
